import { useCallback } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { useHistory } from 'react-router';

import { USER_NOTIFICATION } from 'CorePackage/MainModule/routes/routes';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IconNotification } from 'UIPackage/IconsModule/components/IconNotification';
import { getUserNotificationUnreadCount } from 'UserNotificationPackage/MainModule/selectors/userNotificationSelectors';

import styles from './NotificationIcon.module.scss';

interface INotificationIconStoreProps {
  userNotificationUnreadCount: number;
}

const NotificationIconWithoutStore = ({ userNotificationUnreadCount }: INotificationIconStoreProps) => {
  const history = useHistory();

  const navigateToNotifiesPage = useCallback(() => {
    history.push(USER_NOTIFICATION);
  }, [history]);

  return (
    <>
      <div
        className={styles.NotificationIconWrapper}
        data-tip="React-tooltip"
        data-for="notification-icon-tooltip"
        onClick={navigateToNotifiesPage}
      >
        <IconNotification />
        {!!userNotificationUnreadCount && (
          <div className={styles.Indicator}>
            {userNotificationUnreadCount > 99 ? '99+' : userNotificationUnreadCount}
          </div>
        )}
      </div>
      <ReactTooltip className={styles.Tooltip} place="left" type="dark" effect="solid" id="notification-icon-tooltip">
        <span>{!userNotificationUnreadCount ? 'Нет непрочитанных уведомлений' : 'Есть непрочитанные уведомления'}</span>
      </ReactTooltip>
    </>
  );
};

const mapStateToProps = (state: IRootState): INotificationIconStoreProps => ({
  userNotificationUnreadCount: getUserNotificationUnreadCount(state),
});

export const NotificationIcon = connect(mapStateToProps)(NotificationIconWithoutStore);
